import * as React from "react"

type Parameters = {
	className: string
	isEnabled: boolean
	animId?: unknown
}

export default function useTransientAnimation<Element extends HTMLElement>({
	className,
	isEnabled,
	animId,
}: Parameters) {
	const ref = React.useRef<Element>(null)
	// biome-ignore lint/correctness/useExhaustiveDependencies: This is intentional.
	React.useEffect(() => {
		const element = ref.current
		if (element != null && isEnabled) {
			element.classList.remove(className)
			// Force reflow or the animation might not restart.
			element.offsetWidth
			element.classList.add(className)
			return () => {
				element.classList.remove(className)
			}
		}
	}, [className, isEnabled, animId])
	return ref
}
